import { useCallback, useState } from 'react';
import {
  usePersistedSessionState,
  useTracking,
} from '@edreamsodigeo/frontend-core';
import { usePersistedFlightSelection } from 'clientState/hooks/usePersistedFlightSelection/usePersistedFlightSelection';

const trackFireEventName = 'qualtrics:mmb_abandoned';

// If this survey ever needs to be enabled, make sure this critical bug is solved
// before: https://jira.edreamsodigeo.com/browse/FC-6178
const useAlternativeAbandonmentEvents = () => {
  const [surveySent, setSurveySent] = useState(false);
  const { trackFireEvent } = useTracking();

  const [alternativeFlight] = usePersistedSessionState('alternativeFlight');
  const [flightSelectionData = {}] = usePersistedFlightSelection();

  return useCallback(() => {
    const selectedItineraryId = flightSelectionData?.data?.fareItineraryKey;
    const alternativeItinerary = alternativeFlight?.alternativeItinerary;
    const isAlternativeChosen =
      selectedItineraryId &&
      alternativeItinerary &&
      selectedItineraryId === alternativeItinerary?.id;
    const hasBeenInSummary = window.Odigeo?.History?.queue?.some((url) =>
      url.includes('checkout_flight_summary_results')
    );
    if (isAlternativeChosen && hasBeenInSummary && !surveySent) {
      trackFireEvent(trackFireEventName);
      setSurveySent(true);
    }
  }, [flightSelectionData, alternativeFlight, surveySent, trackFireEvent]);
};

const useLaunchAlternativeAbandonmentEvents = () => {
  const { trackFireEvent } = useTracking();

  return useCallback(() => {
    trackFireEvent(trackFireEventName);
  }, [trackFireEvent]);
};

export {
  useAlternativeAbandonmentEvents,
  useLaunchAlternativeAbandonmentEvents,
};
